export const EstatusCompra = {
    NoAplica: 0,
    FONDOS_INSUFICIENTES: 1,
    PENDIENTE_AUTORIZACION: 2,
    APROBADO_CLIENTE: 3,
    APROBADO_AGENTE: 4,
    PAGADO: 5,
}
